module.exports = __webpack_public_path__ + "img/UG.98d64e7c.svg";